import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export type ClientRating = 'good' | 'regular' | 'bad' | null;

export function useClientRatings(clientIds: string[]) {
  const [ratings, setRatings] = useState<Map<string, ClientRating>>(new Map());
  const [loading, setLoading] = useState(true);

  const key = clientIds.slice().sort().join(',');

  useEffect(() => {
    if (clientIds.length === 0) {
      setRatings(new Map());
      setLoading(false);
      return;
    }

    const fetchRatings = async () => {
      setLoading(true);
      try {
        const { data, error } = await supabase.rpc('get_client_ratings_batch', {
          p_contract_ids: clientIds,
        });

        if (error) throw error;

        const ratingsMap = new Map<string, ClientRating>();
        for (const row of (data as { contract_id: string; rating: ClientRating }[] | null) ?? []) {
          ratingsMap.set(row.contract_id, row.rating);
        }
        setRatings(ratingsMap);
      } catch (error) {
        console.error('Error fetching client ratings:', error);
        setRatings(new Map());
      }
      setLoading(false);
    };

    fetchRatings();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return { ratings, loading };
}
